import type { Curve, CurvePath, LineCurve3, QuadraticBezierCurve3 } from '@anov/3d-core'
import { Vector3 } from '@anov/3d-core'
import { RoundedCornersCurve } from '../../core/Curve/RoundedCornersCurve'

const closure = (curves: Curve<Vector3>[]) => {
  if (curves.length <= 1)
    return false

  const { x: x1, y: y1, z: z1 } = curves[0].type === 'LineCurve3' ? (curves[0] as LineCurve3).v1 : (curves[0] as QuadraticBezierCurve3).v0
  const { x: x2, y: y2, z: z2 } = (curves[curves.length - 1] as LineCurve3).v2

  return x1 === x2 && y1 === y2 && z1 === z2
}

/**
 * offset path
 * @param originalPath
 * @param offsetDistance
 * @returns
 */
export const createOffsetPath = (originalPath: CurvePath<Vector3>, offsetDistance: number, corner = 10) => {
  const curves = originalPath.curves
  const newPoints = []

  const isClosure = closure(curves)
  const firstNormal = new Vector3()
  let nextPoint = (curves[0] as LineCurve3).v1

  for (let i = 0; i < curves.length; i++) {
    if (curves[i].type === 'LineCurve3') {
      const v1 = nextPoint.clone()
      const v2 = (curves[i] as LineCurve3).v2

      const direction = new Vector3().subVectors(v2, v1).normalize()
      const normal = new Vector3().crossVectors(direction, new Vector3(0, 1, 0)).normalize()

      i === 0 && firstNormal.copy(normal)

      const offset = normal.multiplyScalar(offsetDistance)
      const newV1 = v1.clone().add(offset.clone())
      const newV2 = v2.clone().add(offset.clone())

      newPoints.push(newV1)
      nextPoint = newV2
    }

    if (i === curves.length - 1) {
      if (isClosure)
        newPoints[0] = nextPoint.clone().add(firstNormal.multiplyScalar(offsetDistance))
      else
        newPoints.push(nextPoint)
    }
  }

  return new RoundedCornersCurve(newPoints, corner, isClosure)
}
